import React from 'react';
import DateRangeFilter, { DateRangeFilterValue } from './DateRangeFilter';

interface DashboardHeaderProps {
  title?: string;
  subtitle?: string;
  dateFilterValue: DateRangeFilterValue;
  onDateFilterChange: (value: DateRangeFilterValue) => void;
  loading?: boolean;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  title = 'Dashboard Overview',
  subtitle,
  dateFilterValue,
  onDateFilterChange,
  loading = false,
}) => {
  return (
    <header className="dashboard-section dashboard-header">
      <div className="dashboard-header-left">
        <h1 className="dashboard-header-title">{title}</h1>
        {subtitle && <p className="dashboard-header-subtitle">{subtitle}</p>}
      </div>
      <div className="dashboard-header-controls">
        <DateRangeFilter
          value={dateFilterValue}
          onChange={onDateFilterChange}
          loading={loading}
        />
      </div>
    </header>
  );
};
